<template>
  <nav>
    <ul id="gnb-warp" v-if="isWidth">
      <li
        class="gnbList"
        :class="[{ Active: isComp }, { Active: routeNm === 'CompIntroduc' }]"
        @mouseover="mouseover('comp')"
        @mouseleave="mouseleave"
      >
        <router-link to="/Comp-introduc"> 회사소개 </router-link>
      </li>
      <li
        class="gnbList"
        :class="[{ Active: isBuns }, { Active: routeNm === 'BusinessArea' }]"
        @mouseover="mouseover('buns')"
        @mouseleave="mouseleave"
      >
        <router-link to="/business-area"> 사업영역 </router-link>
      </li>
      <li
        class="gnbList"
        :class="[{ Active: isPerf }, { Active: routeNm === 'Performance' }]"
        @mouseover="mouseover('perf')"
        @mouseleave="mouseleave"
      >
        <router-link to="/Performance"> 주요실적 </router-link>
      </li>
      <li
        class="gnbList"
        :class="[{ Active: isRecr }, { Active: routeNm === 'Recruitment' }]"
        @mouseover="mouseover('recr')"
        @mouseleave="mouseleave"
      >
        <router-link to="/Personnel"> 채용정보 </router-link>
      </li>
      <li
        class="gnbList"
        :class="[{ Active: isInfo }, { Active: routeNm === 'CustomerService' }]"
        @mouseover="mouseover('info')"
        @mouseleave="mouseleave"
      >
        <router-link to="/Customer-service"> 고객센터 </router-link>
      </li>
    </ul>
    <ul id="sub-gnb-warp" :class="{ subBack: isBack }">
      <li
        class="sub-gnb-list"
        v-show="isComp"
        @mouseover="mouseover('comp')"
        @mouseleave="mouseleave"
        v-for="(comp, idx) in items.comp"
        :key="`comp_${idx}`"
      >
        <router-link :to="comp.url"> {{ comp.name }} </router-link>
      </li>
      <li
        class="sub-gnb-list"
        v-show="isBuns"
        @mouseover="mouseover('buns')"
        @mouseleave="mouseleave"
        v-for="(buns, idx) in items.buns"
        :key="`buns_${idx}`"
      >
        <router-link :to="buns.url"> {{ buns.name }} </router-link>
      </li>
      <li
        class="sub-gnb-list"
        v-show="isPerf"
        @mouseover="mouseover('perf')"
        @mouseleave="mouseleave"
        v-for="(perf, idx) in items.perf"
        :key="`perf_${idx}`"
      >
        <router-link :to="perf.url"> {{ perf.name }} </router-link>
      </li>
      <li
        class="sub-gnb-list"
        v-show="isRecr"
        @mouseover="mouseover('recr')"
        @mouseleave="mouseleave"
        v-for="(recr, idx) in items.recr"
        :key="`recr_${idx}`"
      >
        <router-link :to="recr.url"> {{ recr.name }} </router-link>
      </li>
      <li
        class="sub-gnb-list"
        v-show="isInfo"
        @mouseover="mouseover('info')"
        @mouseleave="mouseleave"
        v-for="(info, idx) in items.info"
        :key="`info_${idx}`"
      >
        <router-link :to="info.url"> {{ info.name }} </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      isWidth: true,
      isComp: false,
      isBuns: false,
      isPerf: false,
      isRecr: false,
      isInfo: false,
      isBack: false,
      items: {
        comp: [
          {
            url: '/Comp-introduc',
            name: 'CEO인사말',
          },
          {
            url: '/Comp-introduc/Corp-ideology',
            name: '기업이념',
          },
          {
            url: '/Comp-introduc/History',
            name: '회사연혁',
          },
          {
            url: '/Comp-introduc/Organization-chart',
            name: '조직도',
          },
          {
            url: '/Comp-introduc/FindWay',
            name: '오시는길',
          },
        ],
        buns: [
          {
            url: '/business-area',
            name: '시설관리',
          },
          {
            url: '/business-area/logiMana',
            name: '물류관리',
          },
          {
            url: '/business-area/secuMana',
            name: '보안/주차관리',
          },
          {
            url: '/business-area/admiMana',
            name: '미화관리',
          },
          {
            url: '/business-area/hotelMana',
            name: '호텔 위탁운영',
          },
          // {
          //   url: '/business-area/faciMana',
          //   name: '종합관리(P.M)',
          // },
        ],
        perf: [
          {
            url: '/Performance',
            name: '호텔/리조트',
          },
          {
            url: '/Performance/Department-Store',
            name: '백화점/할인점',
          },
          {
            url: '',
            name: '자산관리',
          },
          {
            url: '/Performance/Distribution',
            name: '유통',
          },
          {
            url: '/Performance/perf-etc',
            name: '기타',
          },
        ],
        recr: [
          {
            url: '/Personnel',
            name: '채용정보',
          },
          // {
          //   url: '',
          //   name: '채용정보',
          // },
          // {
          //   url: '',
          //   name: '입사지원안내',
          // },
        ],
        info: [
          {
            url: '/Customer-service',
            name: '뉴스&공지사항',
          },
          {
            url: '/Customer-service/Reference-room',
            name: '자료실',
          },
        ],
      },
    }
  },
  watch: {},
  methods: {
    mouseover(NavNm) {
      if (NavNm === 'comp') this.isComp = true
      if (NavNm === 'buns') this.isBuns = true
      if (NavNm === 'perf') this.isPerf = true
      if (NavNm === 'recr') this.isRecr = true
      if (NavNm === 'info') this.isInfo = true
      this.isBack = true
    },
    mouseleave() {
      this.isComp = false
      this.isBuns = false
      this.isPerf = false
      this.isRecr = false
      this.isInfo = false
      this.isBack = false
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
}
</script>

<style></style>
